import ErrorBox from './_ErrorBox';

export default ErrorBox;
